import { SelectOptions } from "../select-options";

export const fromCountries = [
  {
    id: 1,
    mainText: "Georgia",
  },
  {
    id: 2,
    mainText: "Uzbekistan",
  },
  {
    id: 3,
    mainText: "Ukraine",
  },
];
export default function SelectFromCountryFlow({
  onSelect,
}: {
  onSelect: (selectedValue) => void;
}) {
  return (
    <SelectOptions
      options={fromCountries}
      onSelect={onSelect}
      searchPlaceholder="Search for country"
    />
  );
}
